import { render, staticRenderFns } from "./caja.vue?vue&type=template&id=68522246&scoped=true&"
import script from "./caja.vue?vue&type=script&lang=ts&"
export * from "./caja.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68522246",
  null
  
)

export default component.exports